@if (parameters?.header_main_search) {
  <div class="relative" data-testid="search-box-container">
    <div
      class="flex items-center p-4 gap-2 md:gap-2 rounded-full md:px-6 md:py-2 md:h-12 header-search"
      data-testid="search-box-input-container"
      (click)="searchOpen()">
      <i class="pi pi-search text-lg" data-testid="search-box-icon"></i>
      <input
        pInputText
        type="text"
        class="w-full !bg-transparent !border-0 !outline-none !shadow-none hidden md:block placeholder:text-xs lg:placeholder:text-base"
        data-testid="search-box-input"
        placeholder="{{ 'What are you looking for' | translate }}?"
        (click)="searchOpen()" />
    </div>
  </div>
} @else {
  <div class="flex justify-between flex-wrap" data-testid="search-box-filter-container">
    <div class="flex items-center justify-center">
      <p-button
        icon="pi pi pi-sliders-v"
        data-testid="search-box-filter-btn"
        [rounded]="true"
        [outlined]="true"
        [severity]="'secondary'"
        label="{{ 'Filters' | translate }}"
        [iconPos]="'left'"
        (click)="searchOpen()" />
    </div>
    <div class="flex items-center justify-center" data-testid="search-box-create-container">
      <ng-content select="[create]" />
    </div>
  </div>
}

<p-dialog
  contentStyleClass="border-black-alpha-20  p-0 bg-transparent "
  maskStyleClass="searchdesign"
  appendTo="body"
  data-testid="search-box-dialog"
  header=" {{
    parameters?.header_main_search ? ('General search' | translate) : ('Search in app' | translate)
  }}"
  [closable]="true"
  [styleClass]="'border-none bg-black-alpha-70 '"
  [dismissableMask]="true"
  [modal]="true"
  [showHeader]="true"
  [maximizable]="true"
  [breakpoints]="{ '960px': '75vw', '640px': '99vw' }"
  [style]="{ width: '80vw', 'backdrop-filter': 'blur(80px)' }"
  [(visible)]="globalSearchSideBar"
  (onHide)="globalSearchSideBar = false">
  <ng-template #content>
    <div class="grip w-full max-w-full" data-testid="search-box-dialog-content">
      <ng-content />
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="flex flex-row-reverse flex-wrap">
      <div class="flex items-center justify-center">
        <button
          type="submit"
          pButton
          class="px-2 py-1 p-button-rounded mr-1 text-blue-600 text-xs"
          style="white-space: nowrap"
          data-testid="search-box-submit-btn"
          (click)="submit()">
          <mat-icon>manage_search</mat-icon>
          {{ 'Search' | translate }}
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>
